import { useEffect, useState } from "react";
import { IGetFeedback, FeedbackTypeId } from "../../../../../shared/utils/interfaces/commentsFaces";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import ProfileImage from "../../../../../shared/components/NavBar/profileImage";
import { ReactComponent as ClipboardList } from '../../../../../shared/assets/images/ClipboardList.svg';
import { ReactComponent as Line } from '../../../../../shared/assets/images/Line.svg'
import { selectCurrentUser } from "../../../../authentication/slice/authSlice";
import { useDispatch, useSelector } from 'react-redux'
import { setDeleteEvaluationModal, selectDeleteEvaluationModal, selectIsLoadingEvaluationData, selectEvaluationId, setIsStartingWithEvaluationKit } from "../../../../interview/slice/interviewSlice"
import { Button } from "antd";
export default function FeedbackEvaluation({ feedback, onShowPreview, onDelete, onEdit }: { feedback: IGetFeedback, onShowPreview: (evaluationId: number) => void, onDelete: (evaluationId: number) => void, onEdit: (evaluationId: number) => void }) {

    const user = useSelector(selectCurrentUser);
    const dispatch = useDispatch();
    const deleteModalOpen = useSelector(selectDeleteEvaluationModal)
    const isLoadingEvaluationData = useSelector(selectIsLoadingEvaluationData)
    const evaluationId = useSelector(selectEvaluationId)
    const isEditable = feedback?.userId === user?.id
    const [postedSince, setPostedSince] = useState<string>();
    const [isClickEditing, setIsClickEditing] = useState(false)
    const { addEvaluation, editEvaluation, rejectedCandidate, deleteEvaluation } = FeedbackTypeId;
    useEffect(() => {
        dayjs.extend(relativeTime)
        setPostedSince(dayjs().to(dayjs(feedback?.createdAt)))
    }, [feedback?.createdAt])
    const handelToggleDeleteModal = () => {
        onDelete(feedback?.data?.evaluationId)
        dispatch(setDeleteEvaluationModal(!deleteModalOpen))
    }
    const showPreviews = () => {
        setIsClickEditing(false)
        onShowPreview(feedback?.data?.evaluationId);
    }
    const handleOpenEditEvaluationModal = () => {
        dispatch(setIsStartingWithEvaluationKit(true))
        setIsClickEditing(true)
        onEdit(feedback?.data?.evaluationId)
    }

    return (
        <>
            <div className='flex items-start gap-[0.875rem] mt-4 mb-5 flex-nowrap pe-2'>
                <ProfileImage name={feedback?.name} className="-mt-1" />
                <div>
                    <div className='flex flex-nowrap mb-2.5 gap-2 flex-col items-start'>
                        <div className='flex items-center gap-2'>
                            <span className='text-sm font-semibold text-gray-600 break-all me-2 md:me-0'>{feedback?.name}</span>
                            <span className="hidden md:inline text-xs font-normal text-gray-600 whitespace-nowrap">
                                {`${feedback?.feedbackTypeId === addEvaluation ? `Added ` : feedback?.feedbackTypeId === editEvaluation ? 'Updated' : feedback?.feedbackTypeId === rejectedCandidate ? 'Rejected' : 'Deleted'} ${feedback?.feedbackTypeId === rejectedCandidate ? 'this candidate' : 'evaluation'}`}
                            </span>
                            <span className='inline text-xs font-normal text-gray-400 whitespace-nowrap'>{postedSince}</span>
                        </div>
                        {
                            feedback?.feedbackTypeId === rejectedCandidate ? (
                                <>
                                    <span className='hidden md:inline text-sm text-gray-600 break-words min-w-fit'>
                                        {`Rejected  ${feedback?.data?.rejectionReason ? `due to "${feedback?.data?.rejectionReason}"` : ""}. `}
                                    </span>
                                    <span className='text-xs md:hidden text-gray-600 break-words min-w-fit'>
                                        {`Rejected this candidate ${feedback?.data?.rejectionReason ? `due to "${feedback?.data?.rejectionReason}"` : ""}. `}
                                    </span>
                                </>
                            ) : (
                                <>
                                        <span className='text-xs md:text-sm text-gray-600 break-words min-w-fit'>{
                                            `${feedback?.feedbackTypeId === addEvaluation ? `Added ` : feedback?.feedbackTypeId === editEvaluation ? 'Updated' : 'Deleted'} evaluation for the`
                                        }
                                            <span className="capitalize">{` ${feedback?.data?.job?.title} `}</span>
                                            job.
                                        </span>
                                </>
                            )
                        }

                    </div>
                    {
                        feedback?.isLastVersion && feedback?.feedbackTypeId !== deleteEvaluation ?
                            <div className="flex flex-col md:flex-row items-start md:items-center gap-3">
                                <Button className={`flex items-center gap-2 text-sm text-gray-600  max-w-fit !py-8 !border-none rounded-md ${isEditable ? `bg-gray-200` : `border border-gray-300 cursor-not-allowed`}`}
                                    onClick={showPreviews} loading={isLoadingEvaluationData && feedback?.data?.evaluationId === evaluationId && !isClickEditing}>
                                    <ClipboardList />
                                    <div className="cursor-pointer break-words">
                                        <p className="break-words">{feedback?.data?.kitTitle}</p>
                                        {/* <p>Evaluation score <span className="font-bold">8/10</span></p> */}
                                    </div>
                                </Button>
                                {isEditable ?
                                    <div className="flex items-center font-medium">
                                        <Button className="text-indigo-700 border-none shadow-none text-xs pr-0" loading={isLoadingEvaluationData && feedback?.data?.evaluationId === evaluationId && isClickEditing} onClick={handleOpenEditEvaluationModal}>
                                            Edit
                                        </Button>
                                        <Line className='mx-4' />
                                        <button className="text-red-600 text-xs" onClick={handelToggleDeleteModal}>
                                            Delete
                                        </button>
                                    </div>
                                    : ''
                                }
                            </div> : ''
                    }
                </div>
            </div>
        </>
    )
}